import React from 'react';
import {
  useFileArchiveInfo,
  useIsRegeneratingProject,
  useIsRestrictedArchivedProject,
  useIsStatusNullOrUndefined,
  useProjectWidgetId,
} from './ProjectPreviewModalContext';

export interface ProjectPreviewModalVideoStatusLabelProps {
  children: (label: React.ReactNode) => React.ReactElement;
}

const ProjectPreviewModalVideoStatusLabel: React.FC<ProjectPreviewModalVideoStatusLabelProps> = ({
  children,
}) => {
  const widgetId = useProjectWidgetId();
  const isRegeneratingProject = useIsRegeneratingProject();
  const isStatusNullOrUndefined = useIsStatusNullOrUndefined();

  const isRestrictedArchivedProject = useIsRestrictedArchivedProject();
  const { isFileArchived, isRestoreInProgress } = useFileArchiveInfo();

  const isNotExported = !widgetId || isStatusNullOrUndefined;

  if (isRestrictedArchivedProject) {
    return children(
      <span>This video has been archived. Upgrade to pro to restore.</span>,
    );
  }

  if (isFileArchived) {
    return children(
      <span>
        This video has been archived. Restore it to regain access for 30 days.
      </span>,
    );
  }

  if (isRestoreInProgress) {
    return children(
      <span>
        This video will be ready soon.
        <br />
        <br />
        Archived videos can take up to 24 hours to be restored. Please check
        back then.
      </span>,
    );
  }

  if (isNotExported) {
    return children(<span>your video hasn't been exported yet</span>);
  }

  if (isRegeneratingProject) {
    return children(<span>This video will be ready soon</span>);
  }

  return null;
};

export default ProjectPreviewModalVideoStatusLabel;
